var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriorityButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 15,
    viewBox: "0 0 3 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22391 10.52C2.03724 10.7067 1.80391 10.8 1.52391 10.8C1.24391 10.8 1.00391 10.7067 0.803906 10.52C0.61724 10.32 0.51724 10.08 0.503906 9.8L0.263906 1.54C0.250573 1.23333 0.350573 0.966666 0.563906 0.739999C0.790573 0.513333 1.05724 0.4 1.36391 0.4H1.68391C1.99057 0.4 2.25057 0.513333 2.46391 0.739999C2.69057 0.966666 2.79724 1.23333 2.78391 1.54L2.54391 9.8C2.53057 10.08 2.42391 10.32 2.22391 10.52ZM1.58391 12.4C1.89057 12.4 2.15724 12.5133 2.38391 12.74C2.61057 12.9667 2.72391 13.2333 2.72391 13.54V13.86C2.72391 14.1667 2.61057 14.4333 2.38391 14.66C2.15724 14.8867 1.89057 15 1.58391 15H1.46391C1.15724 15 0.890573 14.8867 0.663906 14.66C0.43724 14.4333 0.323906 14.1667 0.323906 13.86V13.54C0.323906 13.2333 0.43724 12.9667 0.663906 12.74C0.890573 12.5133 1.15724 12.4 1.46391 12.4H1.58391Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityButton);
export default __webpack_public_path__ + "static/media/priority-button.bd2fd873ba8bbb4af50143c068dc9e0b.svg";
export { ForwardRef as ReactComponent };